import { ReactNode } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDCircularLoader from "components/MDCircularLoader";
import PageLayout from "examples/LayoutContainers/PageLayout";
import OneWireLogo from "assets/images/OneWireLogo_2.svg";

// The shared two-panel auth layout (branding panel + centered form column),
// extracted verbatim from the sign-in page so login and connect look identical.
interface Props {
  title: string;
  subtitle?: string;
  loading?: boolean;
  children: ReactNode;
}

function AuthShell({ title, subtitle, loading, children }: Props): JSX.Element {
  return (
    <PageLayout>
      <Grid container>
        {loading && <MDCircularLoader overlayloader startLoader />}
        <Grid item xs={12} lg={6}>
          <MDBox
            display={{ xs: "none", lg: "flex" }}
            alignItems="center"
            width="calc(100% - 2rem)"
            height="calc(100vh - 2rem)"
            borderRadius="lg"
            ml={2}
            mt={2}
          >
            <MDBox
              display={{ xs: "none", lg: "flex" }}
              alignItems="center"
              justifyContent="center"
              width="45%"
              height="calc(100vh - 2rem)"
              bgColor="grey-800"
              sx={{ borderTopLeftRadius: "16px", borderBottomLeftRadius: "16px" }}
            ></MDBox>
            <MDBox
              display={{ xs: "none", lg: "flex" }}
              alignItems="center"
              justifyContent="center"
              width="55%"
              height="calc(100vh - 2rem)"
              bgColor="white"
              sx={{ borderTopRightRadius: "16px", borderBottomRightRadius: "16px" }}
            >
              <img
                src={OneWireLogo}
                alt="logo"
                style={{ width: "20%", position: "absolute", marginLeft: "-20.5%" }}
              />
            </MDBox>
          </MDBox>
        </Grid>
        <Grid item xs={11} sm={8} md={6} lg={4} xl={3} sx={{ mx: "auto" }}>
          <MDBox display="flex" flexDirection="column" justifyContent="center" height="100vh">
            <MDBox py={3} px={3} textAlign="center">
              <MDBox mb={1} textAlign="center">
                <MDTypography variant="h4" fontWeight="bold">
                  {title}
                </MDTypography>
              </MDBox>
              {subtitle ? (
                <MDTypography variant="body2" color="text" fontWeight="regular">
                  {subtitle}
                </MDTypography>
              ) : null}
            </MDBox>
            <MDBox p={3}>{children}</MDBox>
          </MDBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

export default AuthShell;
